import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Fetch distinct values across all visible projects for the given fields.
 * Used to power <datalist>-driven autocomplete on the New/Edit project
 * inputs so ops enter the same spelling every time.
 *
 * Returns { developer: [...], operator: [...], panel_manufacturer: [...],
 *           inverter_manufacturer: [...] } (arrays are alphabetised).
 */
export function usePortfolioMetaOptions() {
  const [options, setOptions] = useState({
    developer: [],
    operator: [],
    panel_manufacturer: [],
    inverter_manufacturer: [],
  });
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/pm/dashboard");
        if (!alive) return;
        const sets = {
          developer: new Set(),
          operator: new Set(),
          panel_manufacturer: new Set(),
          inverter_manufacturer: new Set(),
        };
        for (const list of Object.values(data?.projects_by_status || {})) {
          for (const p of list) {
            for (const f of Object.keys(sets)) {
              const v = (p[f] || "").trim();
              if (v) sets[f].add(v);
            }
          }
        }
        setOptions(Object.fromEntries(
          Object.entries(sets).map(([k, s]) => [k, [...s].sort((a, b) => a.localeCompare(b))])
        ));
      } catch { /* silent — fall back to no suggestions */ }
    })();
    return () => { alive = false; };
  }, []);
  return options;
}
